// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___uCcP8";
var _2 = "styles-module__subtitle___acvXc";
var _3 = "styles-module__text___LJRr4";
var _4 = "styles-module__title___acgWs";
export { _1 as "container", _2 as "subtitle", _3 as "text", _4 as "title" }
